import React from 'react';

import { Resources } from '@ragu-components/ord-resources';

import type { OrdResourceProps } from '@ragu-components/ord-resources';
import type { Calendar } from '@ragu-components/ord-types';

const CalendarsList = React.lazy(async () => import('./CalendarsList'));

export const calendarsResource: OrdResourceProps = {
  key: Resources.calendars,
  name: Resources.calendars,
  list: <CalendarsList />,
  options: {},
  recordRepresentation: (record: Calendar): string => record.title,
};
